<template>
  <SPAPagination class="pagination" reverseOrder hideTextPerPage noPadding minimalItemRange minimalPageNumber textPerPage="Items per page" :pagination="drawerPagination" @changePage="changePage" />
</template>

<script>
import { storeToRefs } from 'pinia';
import SPAPagination from '../../../../components/SPAPagination.vue';
import { useProjectTaggingStore } from '../../../../stores/projectTagging';
export default {
  components: { SPAPagination },
  setup() {
    const projectTagging = useProjectTaggingStore();
    const { drawerPagination, drawerSearch, drawerListContainerLoader, selectedDrawerFilter } = storeToRefs(projectTagging);
    const changePage = async (paginate) => {
      const params = {
        PageNumber: paginate.currentPage,
        RowsPerPage: paginate.itemsPerPage,
        SearchString: drawerSearch.value,
        FilterBy: selectedDrawerFilter.value,
      };
      drawerListContainerLoader.value = true;
      await projectTagging.getEmployeeLookup(params);
    };
    return {
      drawerPagination,
      changePage,
    };
  },
};
</script>
